module.exports = __webpack_public_path__ + "static/media/s1.cd049a7b.png";